module.exports = ".auditoriaCheck{display:inline-flex;float:right;padding:1vh}\n"